export default __webpack_public_path__ + "static/media/ID.a869fd32.svg";